unit LocationItemListType;
{

/* Initail. */

}
interface

uses
  JS,
  LocationItemType;

type
  TLocationItemArray = array of TLocationItemType;

  TLocationItemListType = class
    fLocationItemArray: TLocationItemArray;
  public
    property LocationItemArray: TLocationItemArray read fLocationItemArray;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TLocationItemListType.Create(const String_JSON: String);
var JSArray_ListType: TJSArray;
    JSValue_Type: JSValue;
    LocationItemType: TLocationItemType;
begin
  if String_JSON <> 'null' then
  begin
    JSArray_ListType := TJSArray(TJSJSON.parseobject(String_JSON));

    for JSValue_Type in JSArray_ListType do
    begin
      LocationItemType := TLocationItemType.Create(TJSJSON.stringify(JSValue_Type));

      Insert(LocationItemType, fLocationItemArray, High(fLocationItemArray));
    end;
  end;
end;

end.
